import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const TournamentTeamPlayerQuerySchema = PaginationRequestSchema.extend({
  tournamentId: z.string().min(1, "El torneo es requerido"),
  seasonId: z.string().optional(),
  teamId: z.string().optional(),
});
export type TournamentTeamPlayerQueryDTO = z.infer<typeof TournamentTeamPlayerQuerySchema>;

export const CreateTournamentTeamPlayerRequestSchema = z.object({
  tournamentId: z.string().min(1, "El torneo es requerido"),
  seasonId: z.string().optional(),
  teamId: z.string().min(1, "El equipo es requerido"),
  playerId: z.string().min(1, "El jugador es requerido"),
  isCaptain: z.boolean().optional(),
  statusId: z.string().optional(),
});
export type CreateTournamentTeamPlayerRequestDTO = z.infer<typeof CreateTournamentTeamPlayerRequestSchema>;

export const UpdateTournamentTeamPlayerRequestSchema = z.object({
  isCaptain: z.boolean().optional(),
  statusId: z.string().optional(),
});
export type UpdateTournamentTeamPlayerRequestDTO = z.infer<typeof UpdateTournamentTeamPlayerRequestSchema>;

export const TournamentTeamPlayerResponseSchema = z.object({
  id: z.string(),
  tournamentId: z.string(),
  seasonId: z.string().nullable(),
  teamId: z.string(),
  playerId: z.string(),
  isCaptain: z.boolean(),
  statusId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  player: z
    .object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      nickname: z.string().nullable(),
      imageUrl: z.string().nullable(),
    })
    .nullable()
    .optional(),
  team: z
    .object({
      id: z.string(),
      name: z.string(),
      logo: z.string().nullable(),
    })
    .nullable()
    .optional(),
});
export type TournamentTeamPlayerResponseDTO = z.infer<typeof TournamentTeamPlayerResponseSchema>;

export const TournamentTeamPlayersPaginatedResponseSchema = PaginationResponseSchema(TournamentTeamPlayerResponseSchema);
export type TournamentTeamPlayersPaginatedResponseDTO = z.infer<typeof TournamentTeamPlayersPaginatedResponseSchema>;
